
export default (str) => {
  if (str && str.length > 10) {
    return str.substring(0, 10) + '...'
  }
  return str
}



// WEBPACK FOOTER //
// ./src/filters/maxLength.js